export default "__VITE_ASSET__Auia0oeZ__"